import { useTranslation } from "react-i18next";
import { Button, Modal } from "antd";

import greetingIcon from "../../assets/img/greeting-icon.svg";

interface GreetingModalProps {
  open: boolean;
  onClose: () => void;
}

export const GreetingModal = ({ open, onClose }: GreetingModalProps) => {
  const { t } = useTranslation();

  return (
    <Modal
      open={open}
      onCancel={onClose}
      footer={null}
      centered
      width={440}
      className="greeting-modal"
    >
      <div style={{ textAlign: "center", padding: "8px 0 4px" }}>
        <img
          src={greetingIcon}
          width={100}
          height={100}
          alt=""
          style={{ marginBottom: 16 }}
        />
        <h2 style={{ marginBottom: 12 }}>{t("profile.greeting.title")}</h2>
        <p style={{ marginBottom: 8, color: "rgba(0,0,0,0.65)" }}>
          {t("profile.greeting.para1")}
        </p>
        <p style={{ marginBottom: 24, color: "rgba(0,0,0,0.65)" }}>
          {t("profile.greeting.para2")}
        </p>
        <Button type="primary" size="large" onClick={onClose}>
          {t("profile.greeting.close")}
        </Button>
      </div>
    </Modal>
  );
};
